// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2wtKv","legacyBtn":"MutateMid_legacyBtn__nWuM_"};